var cilExpandDown = ["512 512", "<rect width='480' height='32' x='16' y='16' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M16,496H496V368H16Zm32-96H464v64H48Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M416,96H96v37.86L255.923,303.224,416,135.921ZM256.077,256.776,134.478,128H379.291Z' class='ci-primary'/>"];

export { cilExpandDown };

